import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';

const shopItems = [
  'Long leases and legal costs',
  '£8k+ upfront setup and admin',
  'Fit-out and personalisation costs',
  'Utilities, rates, insurance, maintenance',
  'Ongoing bills that change month to month',
  'Time-consuming and complex',
];

const studioItems = [
  'One simple monthly cost',
  'No setup or hidden costs',
  'Fully ready, professionally designed space',
  'Utilities, WiFi, cleaning, maintenance included',
  'Predictable and stress-free',
  'Focus on your clients, not the admin',
];

export default function ComparisonSection() {
  return (
    <section className="bg-[#FAF9F6] py-12 sm:py-16" data-testid="comparison-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        {/* Introduction */}
        <div className="text-center mb-8">
          <h3 className="font-heading text-xl sm:text-2xl font-medium text-[#1A1A1A] tracking-tight mb-3">
            Considering a shop lease — or your next move?
          </h3>
          <p className="text-base text-[#5C5C55] max-w-xl mx-auto leading-relaxed">
            Explore how a Go Freestyle studio compares, whether you're choosing your first business premises or bringing your experience, reputation and clients into a new space.
          </p>
        </div>

        {/* Comparison cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div className="bg-white rounded-2xl p-6 sm:p-8" data-testid="comparison-shop">
            <p className="text-xs tracking-[0.1em] uppercase font-semibold text-[#8A8B85] mb-5">Traditional shop</p>
            <div className="space-y-3.5">
              {shopItems.map((item) => (
                <div key={item} className="flex items-start gap-2.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#8A8B85] mt-1.5 shrink-0" />
                  <p className="text-sm text-[#5C5C55] leading-relaxed">{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#E8EDE5] rounded-2xl p-6 sm:p-8" data-testid="comparison-studio">
            <p className="text-xs tracking-[0.1em] uppercase font-semibold text-[#3A4035] mb-5">Go Freestyle Studios</p>
            <div className="space-y-3.5">
              {studioItems.map((item) => (
                <div key={item} className="flex items-start gap-2.5">
                  <Check className="w-4 h-4 text-[#3A4035] mt-0.5 shrink-0" strokeWidth={2} />
                  <p className="text-sm text-[#1A1A1A] font-medium leading-relaxed">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Closing + CTA */}
        <p className="text-sm text-[#8A8B85] text-center mt-8">Everything you need to run your business — already included.</p>
        <div className="text-center mt-6">
          <Link
            to="/book-a-viewing"
            className="inline-flex items-center gap-2 bg-[#3A4035] text-white rounded-full px-7 py-3.5 text-sm font-medium hover:bg-[#2B3027] transition-colors"
            data-testid="comparison-cta"
          >
            Explore your studio options <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </section>
  );
}
